//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { IConnectedBrandInstagramBusinessAccounts } from '@apis/instagram-settings/gatewayInstagramSettingsApiModel';
import { HashtagsByAccountData } from '@hashtags/queries/hashtagsQueries';
import InstagramBusinessAccountId from '@models/InstagramBusinessAccountId';
import { isDefined } from '@utils/filterPredicates';

/**
 * Gets the default Instagram business account from the connected accounts
 */
export const getDefaultBusinessAccountId = (
  connectedAccounts: IConnectedBrandInstagramBusinessAccounts[] | undefined,
): InstagramBusinessAccountId | undefined => {
  if (!connectedAccounts?.length) {
    return undefined;
  }
  
  const defaultAccount = connectedAccounts.find(account => account.isDefault);
  
  return defaultAccount?.businessAccountId;
};

/**
 * Finds an Instagram business account based on hashtag usage.
 */
export const findInstagramBusinessAccountForHashtagTracking = (
  hashtagsByAccount: HashtagsByAccountData[],
  isMultiHandlehashtagDynamicLimit: boolean = true,
  defaultBusinessAccountId?: InstagramBusinessAccountId,
): InstagramBusinessAccountId | undefined => {
  if (!hashtagsByAccount.length) {
    return undefined;
  }
  
  if (!isMultiHandlehashtagDynamicLimit && isDefined(defaultBusinessAccountId)) {
    const defaultAccount = hashtagsByAccount.find(
      account => account.businessAccountId === defaultBusinessAccountId
    );
    
    if (defaultAccount) {
      return defaultAccount.businessAccountId;
    }
  }
  
  return [...hashtagsByAccount].sort(
    (a, b) => a.usedHashtagCount - b.usedHashtagCount,
  )[0]?.businessAccountId;
};
